import Splide from '@splidejs/splide';
import PopupSlider from './popup';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { breakpoints, isMobile } from './isMobile';


gsap.registerPlugin(ScrollTrigger);

//if (!isMobile()) {
//    ScrollTrigger.create({
//        trigger: '.six-section',
//        start: () => 'top top',
//        end: () => '+=200%',
//        pinSpacing: false,
//        pin: '.six-section__bg-box',
//        pinType: 'transform',
//        scrub: 1,
//    });
//}
export function SixScene() {
    //let tl = gsap.timeline({
    //    scrollTrigger: {
    //        trigger: '.six-section',
    //        start: () => '-20% top',
    //        end: () => '+=20%',
    //        scrub: 1,
    //    }
    //});

    //tl.from('.main-story-link', 2, { scale: 0.3, y: '-30%', autoAlpha: 0 }, '+=1');
    //tl.from('.six-section__text-block', 1, { autoAlpha: 0, y: '50%' }, '-=1');

    gsap.set('.six-section__story-link', { autoAlpha: 0 });
    document.querySelector('.main-story-link').addEventListener('click', (e) => {
        openVideoCarousel(e, 0);
    })
    let storyLinks = document.querySelectorAll('.story-link');
    storyLinks.forEach(link => {
        link.addEventListener('click', openVideoCarousel.bind(link));
    });

    function openVideoCarousel(e, index) {
        e.preventDefault();
        window.openingVideo = true;
        PopupSlider.go(index === undefined ? [...this.parentNode.parentNode.children].indexOf(this.parentNode) + 1 : index);
        document.querySelector('.popup').classList.add('show');
        document.body.classList.add('open-popup');
        storyLinks.forEach(el => {
            el.classList.add('open-popup');
        })
    }
    var slider;
    var sliderElement = document.querySelector('.stories-slider');

    var settings = {};
    settings[breakpoints.mobile] = buildTimeline('mobile');
    settings[breakpoints.tabletUp] = buildTimeline('tabletUp');
    ScrollTrigger.matchMedia(settings);

    function buildTimeline(breakpoint) {
        return function () {
            if (breakpoint === 'mobile') {
                slider = new Splide('.stories-slider', {
                    type: 'slide',
                    perPage: 2,
                    perMove: 2,
                    gap: '5.07vw',
                    speed: 300,
                    pagination: false
                }).mount();

                slider.on('moved', function (newIndex, oldIndex) {
                    var target = newIndex > oldIndex ? this.querySelector('.splide__arrow--next') : this.querySelector('.splide__arrow--prev');
                    if (!target.classList.contains('animate')) {
                        target.classList.add('animate');
                        setTimeout(() => {
                            target.classList.remove('animate');
                        }, 1600);
                    }
                }.bind(sliderElement));
            }
            else if (slider) {
                slider.destroy();
                slider = null;
            }
            let tl2 = gsap.timeline({
                scrollTrigger: {
                    trigger: '.six-section',
                    start: () => 'top top',
                    end: () => '+=100%',
                    scrub: 1,
                    invalidateOnRefresh: true
                }
            });

            tl2
                .to('.six-section__text-block > *', 1, { autoAlpha: 0 }, '+=1')
                .to('.main-story-link img', 1, { opacity: 0.57 }, '-=0.5');
            if (breakpoint === 'mobile') {
                tl2.to('.six-section__bg', 3, { backgroundPosition: '50% 25%' }, '+=3');
            } else {
                tl2.to('.six-section__bg', 3, { backgroundPosition: '50% 35%' }, '+=3');
            }
            tl2.to('.main-story-link img', 1, { opacity: 1 }, '-=2.7')
                .set('.main-story-link', { pointerEvents: 'auto' });
            if (breakpoint === 'mobile') {
                tl2.to('.stories-slider', 1, { autoAlpha: 1 });
            }
            tl2.fromTo('.six-section__story-link', 2, { autoAlpha: 0 }, {
                autoAlpha: 1,
                stagger: {
                    each: 0.5,
                    ease: 'power1.out',
                }
            });

            let tl3 = gsap.timeline({
                scrollTrigger: {
                    trigger: '.six-section__second-scene',
                    start: () => 'top top',
                    end: () => '+=100%',
                    scrub: 1,
                    invalidateOnRefresh: true
                }
            });

            if (breakpoint === 'mobile') {
                tl3.to('.six-section__story-link, .stories-slider', 1, { autoAlpha: 0 });
                tl3.to('.main-story-link', 3, { y: () => '-=100vh' });
            }
            tl3.to('.six-section__bg', 3, { opacity: 0 }, '-=4');
            tl3.to('.six-section__bg-box', 1, { y: '-100vh' }, '-=2.8');
            tl3.to('.six-section', 0.4, { opacity: 0 });
        };
    }
}